module.exports = __webpack_public_path__ + "img/about-left-1.4e479a70.png";